import React, { createContext, useContext, useState, useCallback } from "react";
import { t } from "@/i18n";

const LangContext = createContext(null);
export const useLang = () => useContext(LangContext);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("dsa_lang") || "hu");

  const change = useCallback((l) => {
    setLang(l);
    localStorage.setItem("dsa_lang", l);
  }, []);

  const toggle = useCallback(() => {
    change(lang === "hu" ? "en" : "hu");
  }, [lang, change]);

  const value = { lang, setLang: change, toggle, tr: t[lang] };
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}
